import React from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
import styles from './TableBanners.module.scss';

export function TableErrorBanner(props) {
  const { onRetry } = props;

  return (
    <div className={styles.tableBanner}>
      There was an error fetching your requested data.<small>Please try again.</small>
      {onRetry && (
        <div className={styles.buttonWrapper}>
          <Button onClick={onRetry} text="Click to Retry" />
        </div>
      )}
    </div>
  );
}

TableErrorBanner.propTypes = {
  onRetry: PropTypes.func,
};
